module.exports = __webpack_public_path__ + "img/profile_hover.f6dd7b1d.svg";